import instance from "@/services/api";

export const unsignedSignAPI = {
  _rawClient() {
    return instance(true, null, { throwError: true, showToast: false });
  },

  async getInvoices(params) {
    return await instance()
      .get("/project/unsigned/invoices/", { params })
      .then((res) => res?.data);
  },

  async getAgreements(params) {
    return await instance()
      .get("/project/unsigned/agreements/", { params })
      .then((res) => res?.data);
  },

  async getDocuments(params) {
    return await instance()
      .get("/project/unsigned/documents/", { params })
      .then((res) => res?.data);
  },

  async getDocumentTypes() {
    return await instance()
      .get("/project/common/document_types/read/")
      .then((res) => res?.data);
  },

  async getContractors() {
    return await instance()
      .get("/project/unsigned/contractors/")
      .then((res) => res?.data);
  },

  async getAgrContractors() {
    return await instance()
      .get("/project/unsigned/agr_contractors/")
      .then((res) => res?.data);
  },

  async getEntrances() {
    return await instance()
      .get("/project/unsigned/entrances/")
      .then((res) => res?.data);
  },

  async getEntrancesTree(sbs_project_id) {
    return await instance()
      .get("/project/unsigned/entrances_tree/", { params: { sbs_project_id } })
      .then((res) => res?.data);
  },

  async getFloors(project_entrance_id) {
    return await instance()
      .get("/project/unsigned/floors/", { params: { project_entrance_id } })
      .then((res) => res?.data);
  },

  async getDocumentsCascade(params = {}) {
    return await instance()
      .get("/project/unsigned/documents/cascade/read/", { params })
      .then((res) => res?.data);
  },

  async getProviders() {
    return await instance()
      .get("/provider_request/provider/")
      .then((res) => res?.data);
  },

  async getProjectTypes() {
    return await instance()
      .get("/project_list/project/type/")
      .then((res) => res?.data);
  },

  async getUspProjects() {
    return await instance()
      .get("/project/project_group/read/")
      .then((res) => res?.data);
  },

  async downloadInvoice(provider_request_invoice_id) {
    return await this._rawClient().get(
      `/supplier/invoice/${provider_request_invoice_id}/download/`,
      { responseType: "blob" }
    );
  },

  async signInvoiceProvider(provider_request_invoice_id) {
    return await instance()
      .post(`/supplier/invoice/${provider_request_invoice_id}/sign/`)
      .then((res) => res?.data);
  },

  async signInvoiceContractor(provider_request_invoice_id, returnUrl) {
    const return_url = returnUrl || (window.location.origin + "/unsigned-sign");
    return await instance()
      .post(`/provider_request/invoice/${provider_request_invoice_id}/sign/`, {
        signer_type: 'contractor',
        return_url,
      })
      .then((res) => res?.data);
  },

  async sendInvoiceTo1C(provider_request_invoice_id, targetSystem) {
    return await instance()
      .post(`/provider_request/invoice/${provider_request_invoice_id}/send_to_1c/`, {
        target_system: targetSystem,
      })
      .then((res) => res?.data);
  },

  async downloadAgreement(project_agreement_id) {
    return await this._rawClient().post(
      `/project/agreement/sign/download/`,
      { project_agreement_id },
      { responseType: "blob" }
    );
  },

  async signAgreement(project_agreement_id, returnUrl) {
    const return_url = returnUrl || (window.location.origin + "/unsigned-sign");
    return await instance()
      .post(`/project/agreement/sign/`, { project_agreement_id, return_url })
      .then((res) => res?.data?.data ?? res?.data);
  },

  async downloadDocument(floor_map_document_id, params = {}) {
    return await this._rawClient().post(
      `/project/documents/signed/download/`,
      { floor_map_document_id, ...params },
      {
        params,
        responseType: "blob",
      }
    );
  },

  async downloadDocumentByMasterUrl(master_url) {
    return await this._rawClient().get(
      master_url,
      { responseType: "blob" }
    );
  },

  async downloadK2svByBuhAvr(floor_map_document_id) {
    return await this._rawClient().post(
      `/project/unsigned/documents/${floor_map_document_id}/k2sv/download/`,
      {},
      { responseType: "blob" }
    );
  },

  async signDocument(floor_map_document_id, returnUrl) {
    const return_url = returnUrl || (window.location.origin + "/unsigned-sign");
    return await instance()
      .post(`/project/documents/sign/`, { floor_map_document_id, return_url })
      .then((res) => res?.data?.data ?? res?.data);
  },

  /** M-19 overrun uses the same signing contract as residential-settings `signM19OverDocument`. */
  async signM19OverDocument(floor_map_document_id, returnUrl) {
    const return_url = returnUrl || (window.location.origin + "/unsigned-sign");
    return await instance()
      .post(`/project/documents/sign/m19_over/`, { floor_map_document_id, return_url })
      .then((res) => res?.data?.data ?? res?.data);
  },

  async batchSignDocuments(document_ids, returnUrl) {
    const return_url = returnUrl || (window.location.origin + "/unsigned-sign");
    return await instance()
      .post(`/project/documents/batch/create/`, { document_ids, return_url })
      .then((res) => res?.data);
  },

  async stornoDocument(floor_map_document_id, storno_date_mode = "today", preview = false, date_storno = null) {
    const body = { storno_date_mode, preview };
    if (date_storno) body.date_storno = date_storno;
    return await instance()
      .post(`/project/unsigned/storno/${floor_map_document_id}/`, body)
      .then((res) => res?.data);
  },

  async deleteBuhGroup(floor_map_document_id) {
    return await instance()
      .delete(`/project/unsigned/buh_group/${floor_map_document_id}/delete/`)
      .then((res) => res?.data)
      .catch(() => null);
  },
};
